import { appRoutes } from "../../utils/appLinks";

export const headItems = [
  {
    key: "about-us",
    name: "About us",
    link: "/about-us",
    isMenuItem: true,
    fullLink: "/onboarding",
  },
  {
    key: "contact-us",
    name: "Contact us",
    link: "/contact-us",
    isMenuItem: true,
    fullLink: "/blog",
  },
  {
    key: "blog",
    name: "Blog",
    link: "/blog",
    isMenuItem: true,
    fullLink: "/blog",
  },
  // {
  //   key: "Artist dashboard",
  //   name: "artist Dashboard",
  //   link: "/dashboard/artist",
  //   isMenuItem: true,
  //   fullLink: "/dashboard/artist",
  // },


  {
    key: "login",
    isMenuItem: true,
    name: "Login",
    link: appRoutes.LOGIN,
    fullLink: "/login",
  },


];
